import { LoadingView } from '@components/LoadingView/LoadingView';
import ReportList from '@components/ReportList/ReportList';
import { useReportsList } from '@hooks/useReportsList';
import type { ReportFiltersValues } from '@components/ReportFilters/reportFilters.types';
import type { ReportResponseDto } from '@api/WhisApi/generated';
import { REPORTS_PAGE_LIMIT } from '@screens/Reports/reportsScreen.constants';
import { useState } from 'react';

interface BoardReportsScreenProps {
  filters?: ReportFiltersValues;
  selectedReportIds?: string[];
  onSelectionChange?: (
    selectedReports: ReportResponseDto[],
    currentPageReports: ReportResponseDto[],
  ) => void;
}

export default function BoardReportsScreen({
  filters,
  selectedReportIds,
  onSelectionChange,
}: BoardReportsScreenProps): React.ReactNode {
  const [pageLimit, setPageLimit] = useState(REPORTS_PAGE_LIMIT);
  const {
    page,
    setPage,
    reportPages,
    reportCount,
    sorting,
    hasFetchedReports,
    hasMore,
    isPending,
    isLoadingMore,
    loadMoreReports,
    handleSortingChange,
  } = useReportsList({ myReports: false, filters, pageLimit });

  if (isPending && !hasFetchedReports) {
    return <LoadingView />;
  }

  return (
    <ReportList
      reportPages={reportPages}
      reportCount={reportCount}
      sortedColumns={sorting}
      setPage={(page) => setPage(page)}
      onSortingChange={handleSortingChange}
      page={page}
      selectedReportIds={selectedReportIds}
      onSelectionChange={onSelectionChange}
      pageSize={pageLimit}
      onPageSizeChange={setPageLimit}
      onLoadMore={loadMoreReports}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
    />
  );
}
